<template>
    <v-tab-item>
        <texting-form :applications="[value]" readonlyAddressees v-bind="{ recruitment, initialForm }" @posted="updateItem" />
        <texting-list v-bind="{ textings }" class="mt-20 mt-lg-40" />
        <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="my-16"></v-pagination>
    </v-tab-item>
</template>

<script>
import { initTexting, initTextingAddressee } from "@/assets/variables";

import TextingForm from "../texting/texting-form.vue";
import TextingList from "../texting/texting-list.vue";
import api from "@/api";

export default {
    components: {
        TextingForm,
        TextingList,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        textings: [],

        page: 1,
        limit: 10,
        query: {},
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        initialForm() {
            return {
                ...initTexting(),
                addressees: [initTextingAddressee(this.value)],
            };
        },

        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.query;
            return { ...query, "addressees._user": this.application?._applicant };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
        page() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, textings } = await api.v1.company.textings.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.textings = textings;
            } finally {
                this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.textings.findIndex((texting) => texting?._id == item?._id);
            if (0 <= index) this.textings.splice(index, 1, item);
            else this.textings = [item, ...this.textings];
        },
    },
};
</script>

<style>
</style>